/* eslint-disable max-classes-per-file */
import { Cellstyle, HotCell } from "~app/common/components/hot-doc/hotdoc/cell";
import { ForsorjningskallaAggregat } from "~app/common/models/forsorjningskalla";

/* eslint-disable no-bitwise */

export class TextCell extends HotCell {

    constructor(private readonly markupBuilder: () => string, rowSpan: number, style) {
        super(style, { rowSpan: rowSpan });
    }

    static create(text, rowSpan = 2, flags = null, link = null): TextCell {
        const buildMarkup = (): string => {
            const linkStart = link ? `<a href="${link}">` : "";
            const linkEnd = link ? "</a>" : "";
            return !!text && text.length > 20
                ? `${linkStart}<span style="white-space: normal;" data-bs-toggle="tooltip" title="${text}">${text.substring(0, 20)}...</span>${linkEnd}`
                : `${linkStart}<span style="white-space: normal;" data-bs-toggle="tooltip" title="${text}">${text}</span>${linkEnd}`;

        };

        return new TextCell(buildMarkup, rowSpan, flags);
    }

    validate = (value: any) => false;
    override onDelete(): void { }
    genHtml = () => this.markupBuilder();
}

export class CellFactory {
    static createKundCell(model: ForsorjningskallaAggregat, flags = null): TextCell {
        const link = `/core/kundorder/${model.kundorderId}`;
        return TextCell.create(model.namn, 2, Cellstyle.Readonly | Cellstyle.AlignRight, link);
    }
}
